export default __webpack_public_path__ + "static/Couture-Regular-799ab2e6a6473776e3856b6ae3c19cb9.ttf";